import { Box, Typography } from "@mui/material";
import NextLink from "next/link";
import Article from "../article/article";
import ArticlesProps from "@/src/_types/Article/articles-props";
import { stripHTMLTags } from "@/src/utils/strip-html-tags";
import { issuePart } from "@/src/utils/textTransform";
import SectionHeading from "@/src/components/common/broadsheet/section-heading";
import MetaLine from "@/src/components/common/broadsheet/meta-line";
import {
  FONT_TEXT,
  hairlineTop,
  microActionSx,
} from "@/src/components/common/broadsheet/tokens";
import VISUALLY_HIDDEN from "@/src/utils/visually-hidden";

const Articles = (props: ArticlesProps) => {
  const count = props.articles?.length ?? 0;

  return (
    <Box component="section">
      {props.hideHeading ? (
        <Typography component="h2" sx={VISUALLY_HIDDEN}>
          {props.title}
        </Typography>
      ) : (
        <SectionHeading
          title={props.title}
          component="h2"
          size={props.headingSize}
        />
      )}

      <MetaLine
        sx={{ mt: props.hideHeading || props.xmlLink ? 0.125 : -0.25, mb: 0.5 }}
        items={[
          `${count} article${count === 1 ? "" : "s"}`,
          props.date,
          issuePart("Vol.", props.volume),
          String(props.volume ?? "").trim() ===
          String(props.caption ?? "").trim()
            ? null
            : issuePart("Issue", props.caption),
          props.xmlLink ? (
            <Box
              key="xml"
              component={NextLink}
              href={props.xmlLink}
              target="_blank"
              sx={microActionSx("custom.link")}
            >
              XML
            </Box>
          ) : null,
        ]}
      />

      {props.desc ? (
        <Typography
          component="p"
          sx={{
            m: 0,
            mb: 0.5,
            maxWidth: "72ch",
            fontFamily: FONT_TEXT,
            fontSize: "0.875rem",
            lineHeight: 1.55,
            color: "custom.inkMuted",
          }}
        >
          {stripHTMLTags(props.desc)}
        </Typography>
      ) : null}

      {count ? (
        (props.articles ?? []).map((article, index) => (
          <Box key={index} sx={{ py: 0.75, ...hairlineTop }}>
            <Article article={article} />
          </Box>
        ))
      ) : (
        <Typography
          component="p"
          sx={{
            m: 0,
            py: 1,
            fontFamily: FONT_TEXT,
            fontSize: "0.875rem",
            color: "custom.inkMuted",
            ...hairlineTop,
          }}
        >
          No articles available.
        </Typography>
      )}
    </Box>
  );
};

export default Articles;
